module.exports = __webpack_public_path__ + "img/finances.3950c186.svg";